import { trpc } from '@web/lib/trpc';

import { DoctorDetailsCard } from './doctors-details-card';

type DoctorDetailsViewProps = {
  doctorId: string;
  onClose?: () => void;
};

export function DoctorDetailsView({
  doctorId,
  onClose,
}: DoctorDetailsViewProps) {
  const { data: doctorDetailsData, refetch: refetchDoctorsData } =
    trpc.doctor.getDetails.useQuery({
      id: doctorId,
    });

  const { mutateAsync: updateDoctorMutation } = trpc.doctor.edit.useMutation();

  const { data: brands } = trpc.brand.listAll.useQuery();

  if (!doctorDetailsData || !brands) return null;

  return (
    <DoctorDetailsCard
      doctor={doctorDetailsData}
      brandsList={brands}
      onClose={() => {
        void refetchDoctorsData();

        onClose?.();
      }}
      onSubmit={async (data) => {
        await updateDoctorMutation(data);
      }}
    />
  );
}
